export default "__VITE_ASSET__CVJD$HQF__"